import { createMuiTheme } from '@material-ui/core/styles';

const defaultTheme = createMuiTheme();
export const theme = createMuiTheme({
    typography: {
        textTransform: 'none',
        textAlign: 'left',
        letterSpacing: '0px',
        fontFamily: 'gt-walsheim-regular',
        opacity: 1,

        body1: {
            fontSize: 16,
            [defaultTheme.breakpoints.down('sm')]: {
                fontSize: 14,
            },
            [defaultTheme.breakpoints.up('sm')]: {
                fontSize: 15,
            },
            [defaultTheme.breakpoints.up('md')]: {
                fontSize: 16,
            },
        },
    },
    palette: {
        primary: {
            main: '#892ba0',
        },
        secondary: {
            main: '#D111C9',
        },
    },
    overrides: {
        MuiTooltip: {            
            tooltip: {
                fontSize: '14',
                maxWidth:620,
            },
        },
        MuiFormLabel: {
            asterisk: {
                color: '#f44336;',
            },
        },        
    },
});
